module.exports = __webpack_public_path__ + "img/alfie-adjo-dede.39f5967c.jpeg";